import { AppRoutes } from "@/lib/router"; // Import renamed component
import { Provider as JotaiProvider } from "jotai";
import { BrowserRouter } from "react-router-dom"; // Remove useLocation since we don't need it anymore
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Footer from "./components/layout/Footer";
import { Toaster } from "./components/ui/toaster";
import { useEffect } from "react";
import { useSetAtom, useAtomValue } from "jotai";
import { authStateAtom, isAuthenticatedAtom } from "@/stores/auth.atom";
import { useCurrentUser } from "@/services/auth.service";
import { ResponsiveProvider } from "@/context/ResponsiveContext";
import {
  ToastProvider,
  NotificationToastContainer,
} from "@/components/ui/NotificationToast";
import type { User } from "@/stores/auth.atom";
import "./index.css";

// Create a client
const queryClient = new QueryClient();

// AuthStateManager component to handle auth state restoration
function AuthStateManager() {
  const { data: currentUser } = useCurrentUser();
  const setAuthState = useSetAtom(authStateAtom);

  useEffect(() => {
    // If we have a token, try to restore auth state
    const token = localStorage.getItem("auth_token");
    if (token && currentUser) {
      setAuthState({
        user: currentUser as User, // Type assertion for mock data
        isAuthenticated: true,
        isLoading: false,
        error: null,
      });
    }
  }, [currentUser, setAuthState]);

  return null;
}

function AppContent() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);

  return (
    <>
      {/* Wrap everything in a flex container to push footer down */}
      <div className="flex flex-col min-h-screen bg-background">
        <main className="flex-grow pt-0 px-[--spacing-page-padding]">
          <AppRoutes />
        </main>
        {/* Center footer - only show when not authenticated */}
        {!isAuthenticated && (
          <div className="flex justify-center">
            <Footer />
          </div>
        )}
      </div>
      <Toaster />
      <NotificationToastContainer />
      <AuthStateManager />
    </>
  );
}

function App() {
  return (
    // Wrap everything in BrowserRouter to provide routing context for Navbar
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <JotaiProvider>
          <ResponsiveProvider>
            <ToastProvider>
              <AppContent />
            </ToastProvider>
          </ResponsiveProvider>
        </JotaiProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
